"use strict";
// Copyright (c) StrangeBee 2023
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
const utils_1 = require("../../utils");
const errors_1 = require("../../errors");
class BrandingController extends __1.ParentController {
    constructor() {
        super(...arguments);
        this.endpoints = {
            list: '/v1/branding',
            edit: '/v1/branding',
            delete: '/v1/branding/assets/:kind',
        };
    }
    list() {
        try {
            return this.manager.get({ url: this.endpoints.list });
        }
        catch (e) {
            (0, utils_1.errorManager)(e, errors_1.GenericError, {
                prefix: 'Cannot retrieve Branding',
                errors: [{ statusCode: 404 }],
            });
        }
    }
    edit(params) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                return this.manager.post({ url: this.endpoints.edit }, params);
            }
            catch (e) {
                (0, utils_1.errorManager)(e, errors_1.GenericError, {
                    prefix: 'Cannot edit Branding',
                    errors: [{ statusCode: 400 }],
                });
            }
        });
    }
    count() {
        throw new Error("Can't count Branding");
    }
    create({}) {
        throw new Error("Can't create Branding!");
    }
    delete(kind) {
        return this.manager.delete({ url: this.endpoints.delete, params: { kind } });
    }
}
exports.default = BrandingController;
